import React from 'react'

import moment from 'moment'

import { Card,
         Row,
         Col,
         Timeline,
         Icon,
         Menu,
         Dropdown,
         Checkbox } from 'antd'

class SessionHistory extends React.Component{

    state={
        viewsVisible:true,
        searchesVisible:true
    }

    render(){
        return(
            <Card
                title={this.props.cardtitle}
                style={{height:800}}
                extra={this.renderOptions()}>

                <Card type="inner">
                    {this.props.itemlist?
                    <Timeline
                        style={{
                                paddingLeft:5,
                                overflow:"auto",
                                height: 650
                                }}>
                        {this.renderSessionHistory(this.props.itemlist)}
                    </Timeline>
                    : "Nothing in session"}
                </Card>
            </Card>
        )
    }

    renderOptions = ()=>{
        const menu = (
            <Menu>
                <Menu.Item>
                    <Checkbox defaultChecked="true" onChange={()=>this.setState({viewsVisible:!this.state.viewsVisible})} disabled={!this.state.searchesVisible}>
                        <Icon type="eye-o" style={{fontSize:16, marginRight:5}}/>View
                    </Checkbox>
                </Menu.Item>
                <Menu.Item>
                    <Checkbox defaultChecked="true" onChange={()=>this.setState({searchesVisible:!this.state.searchesVisible})} disabled={!this.state.viewsVisible}>
                        <Icon type="search" style={{fontSize:16, marginRight:5}}/>Search
                    </Checkbox>
                </Menu.Item>
            </Menu>
        )

        return(
            <Dropdown overlay={menu} placement="bottomRight">
                <a className="ant-dropdown-link">Options</a>
            </Dropdown>
        )
    }

    renderSearch=(item)=>{
        let color, title, dot;

        color = "blue"
        title = item.term
        dot = "search"

        return(
                <Timeline.Item color={color} 
                    dot={<Icon type={dot} style={{ fontSize:16 }}/>}
                    style={{
                        fontSize:10,
                        marginTop:5,
                        paddingBottom: 10,
                        paddingRight:10
                        }}>
                        <Row type="flex" justify="space-between">
                            <Col span={12}>
                                {title}
                            </Col>
                            <Col span={4}>
                                <Row type="flex" justify="center">
                                    {null}
                                </Row>
                            </Col>
                            <Col span={8}>
                                <Row type="flex" justify="end">
                                    {moment(item.date["$date"]).format("DD/MM/YYYY HH:mm:ss a")}
                                </Row>
                            </Col>
                        </Row>
                </Timeline.Item>
        )
    }

    renderView=(item)=>{

        let color, dot, id, link, title, image;
        // console.log(item)

        color = "black"
        title = item.product.title
        dot = "eye-o"
        image = item.product.images[0].url
        id = item.product._id["$oid"]
        link = `https://eezee.sg/preview/${id}`

        return(
                <Timeline.Item color={color} 
                    dot={<Icon type={dot} style={{ fontSize:16 }}/>}
                    style={{
                        fontSize:10,
                        marginTop:5,
                        paddingBottom: 10,
                        paddingRight:10
                        }}>
                        <Row type="flex" justify="space-between">
                            <Col span={12}>
                                <a href={link} target="_blank">{title}</a>
                            </Col>
                            <Col span={4}>
                                <Row type="flex" justify="center">
                                    <img src={image} style={{maxHeight:36, maxWidth:36}} alt="product"/>
                                </Row>
                            </Col>
                            <Col span={8}>
                                <Row type="flex" justify="end">
                                    {moment(item.date["$date"]).format("DD/MM/YYYY HH:mm:ss a")}
                                    <p style={{fontSize:8, opacity:0.5}}>{id}</p>
                                </Row>
                            </Col>
                        </Row>
                </Timeline.Item>
        )
    }

    renderSessionHistory = (itemList)=>{
        
        return(
            itemList.map( (item) => {

                if (item.type === "search" && this.state.searchesVisible){
                    return(
                        this.renderSearch(item)
                    )
                }
                
                if (item.type === "view" && this.state.viewsVisible){
                    return(
                        this.renderView(item)
                    )
                }

                return null;
            })
        )
    }
}

export default SessionHistory


// WEBPACK FOOTER //
// ./src/components/customer-journey/session-history.js